/**
 * How a dashboard's kiosk auto-refresh reads in the UI. 0 means off: the
 * board never reloads itself, so a viewer's filter selections survive.
 */
export function refreshLabel(refreshIntervalSec: number): string {
  return refreshIntervalSec === 0 ? 'No auto-refresh' : `${refreshIntervalSec}s refresh`;
}
